import { getData } from '../utils/data';

/**
 * Header controls.
 */
export default function headerSection() {
	const html = document.getElementsByTagName('html')[0],
    headerToggler = getData(document.getElementById('header-nav'), 'toggler');

	if (headerToggler) {

		headerToggler.on('toggle', _ => {
			html.classList[headerToggler.isOpen ? 'add' : 'remove']('is-header-open');
			if (headerToggler.isOpen) window.scrollTo(0, 0);
		});
	}

	const setupMobileMenu = () => {
		// const link = $('a.mobile-menu-item_link.has-children');
		// const backs = $('.mobile-menu-sub_back');
		const links = document.getElementsByClassName('mobile-menu-item_link');
		const backs = document.getElementsByClassName('mobile-menu-sub_back');

		Array.from(links).filter(link => link.classList.contains('has-children')).forEach(link => {
			// on click event
			/*
			link.on('click', function (e) {
				e.preventDefault();

				const _this = $(this);
				const subMenu = _this.next();

				subMenu.addClass('is-opened');
			});
			*/
			link.addEventListener('click', e => {
				e.preventDefault();
				link.nextElementSibling.classList.add('is-opened');
			});
		});

		for (const back of backs) {
			/*back.on('click', function (e) {
				const $parent = $(this).parent();

				$parent.removeClass('is-opened');
			});*/
			//
			back.addEventListener('click', _ => back.parentElement.classList.remove('is-opened'));
		}
	}

	setupMobileMenu();
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js